import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Intervention from "../../entity/b2csdu/Intervention";

const SERVICE = "service-b2csdu";
const ENTITY = "interventions";

export default function () {
    const {findOneBy, update} = useApi();
    const state = useSelector;
    const newInstance = data => new Intervention(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.b2csdu?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                async exec() {
                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7");
                }
            }
        },
        findOneByToken(token) {
            return {
                select() {
                    const result = state(state => state.api?.b2csdu?.[ENTITY]?.find(i => i?.getToken() == token));

                    if (isNull(result)) return null;

                    return result;
                },
                async exec() {
                    return findOneBy(SERVICE, ENTITY, "token", token, newInstance, "application_v7");
                }
            }
        },
        findOneBySuggestion(id) {
            return {
                select() {
                    const result = state(state => state.api?.b2csdu?.[ENTITY]?.find(i => i?.getSuggestionId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                async exec() {
                    return findOneBy(SERVICE, ENTITY, "suggestion_id", id, newInstance, "application_v7");
                }
            }
        },
        async update(id, property, payload) {
            return update(SERVICE, ENTITY, id, property, payload, newInstance, "application_v7");
        }
    }
}